/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Content_PlaceholderInputs */

const cs_blog_content_placeholder = /** @type {(inputs: Blog_Content_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Začněte psát článek…`)
};

const en_blog_content_placeholder = /** @type {(inputs: Blog_Content_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start writing your article…`)
};

/**
* | output |
* | --- |
* | "Start writing your article…" |
*
* @param {Blog_Content_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_content_placeholder = /** @type {((inputs?: Blog_Content_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Content_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_content_placeholder(inputs)
	return cs_blog_content_placeholder(inputs)
});